function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { accountByIdRef } from '@paperstac/firestore-collections/lib/accounts';
import { accountsByIdentityIdRef } from '@paperstac/firestore-collections/lib/accounts';
import { DEFAULT_MARKETPLACE_ID, isLegacyProfileInScope } from '@paperstac/shared/lib/app';
import createPersistedState from '@paperstac/hooks/lib/createPersistedState';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import React from 'react';
import { getSessionCurrentAccountId, setSessionCurrentAccountId } from '../services/session';
import { getStateStorageAdapter } from '../services/statePersistence';
import { IdentityContext } from './IdentityProvider';
var useAccountsState = createPersistedState('AccountsProviderAccounts', getStateStorageAdapter());
var useCurrentAccountIdState = createPersistedState('AccountsProviderCurrentAccountId', getStateStorageAdapter());
var AccountsContext = /*#__PURE__*/React.createContext();
var Provider = AccountsContext.Provider;
var DEFAULT_STATE = {
  currentAccountId: null,
  accounts: null
};
var AccountsProvider = /*#__PURE__*/React.memo(function (_ref) {
  var _ref$app = _ref.app,
    app = _ref$app === void 0 ? 'paperstac' : _ref$app,
    children = _ref.children;
  var _React$useContext = React.useContext(IdentityContext),
    uid = _React$useContext.uid,
    claims = _React$useContext.claims;
  var _useAccountsState = useAccountsState(DEFAULT_STATE.accounts),
    _useAccountsState2 = _slicedToArray(_useAccountsState, 2),
    accounts = _useAccountsState2[0],
    setAccounts = _useAccountsState2[1];
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    impersonatedAccount = _React$useState2[0],
    setImpersonatedAccount = _React$useState2[1];
  var _useCurrentAccountIdS = useCurrentAccountIdState(DEFAULT_STATE.currentAccountId),
    _useCurrentAccountIdS2 = _slicedToArray(_useCurrentAccountIdS, 2),
    currentAccountId = _useCurrentAccountIdS2[0],
    setCurrentAccountId = _useCurrentAccountIdS2[1];
  var scopedAccounts = React.useMemo(function () {
    var _accounts$filter;
    return uid ? (_accounts$filter = accounts === null || accounts === void 0 ? void 0 : accounts.filter(function (profile) {
      var _profile$members, _profile$members$uid;
      return isLegacyProfileInScope(profile, app) && ((_profile$members = profile.members) === null || _profile$members === void 0 ? void 0 : (_profile$members$uid = _profile$members[uid]) === null || _profile$members$uid === void 0 ? void 0 : _profile$members$uid.id) === uid;
    })) !== null && _accounts$filter !== void 0 ? _accounts$filter : null : null;
  }, [accounts, app, uid]);
  var isAdmin = !!uid && get(claims, 'admin', false);
  var handleCurrentAccountId = React.useCallback(function (currentAccountId) {
    setCurrentAccountId(currentAccountId);
  }, [setCurrentAccountId]);
  React.useEffect(function () {
    if (!uid) {
      setAccounts(DEFAULT_STATE.accounts);
      setCurrentAccountId(DEFAULT_STATE.currentAccountId);
      return;
    }
    var query = accountsByIdentityIdRef(uid).where('app', '==', app);
    if (app === 'paperstac') query = query.where('marketplaceId', '==', DEFAULT_MARKETPLACE_ID);
    return query.onSnapshot(function (qs) {
      var accounts = qs.docs.map(function (ds) {
        return ds.data();
      }).filter(function (profile) {
        return isLegacyProfileInScope(profile, app);
      });
      setAccounts(accounts);
      if (!isAdmin && !accounts.some(function (_ref2) {
        var id = _ref2.id;
        return id === currentAccountId;
      })) {
        handleCurrentAccountId(accounts.length === 1 ? accounts[0].id : null);
      } else if (accounts.length === 1 && !currentAccountId) handleCurrentAccountId(accounts[0].id);
    });
  }, [app, currentAccountId, handleCurrentAccountId, isAdmin, setAccounts, setCurrentAccountId, uid]);
  React.useEffect(function () {
    if (!isAdmin || !currentAccountId || !Array.isArray(scopedAccounts) || !!scopedAccounts.find(function (_ref3) {
      var id = _ref3.id;
      return id === currentAccountId;
    })) {
      setImpersonatedAccount(null);
      return;
    }
    // Preserve the existing admin impersonation capability, restricted to this app/marketplace.
    return accountByIdRef(currentAccountId).onSnapshot(function (docSnap) {
      var profile = docSnap.data();
      setImpersonatedAccount(isLegacyProfileInScope(profile, app) ? profile : null);
    });
  }, [app, isAdmin, scopedAccounts, currentAccountId]);
  var state = React.useMemo(function () {
    var allowedImpersonation = isAdmin && (impersonatedAccount === null || impersonatedAccount === void 0 ? void 0 : impersonatedAccount.id) === currentAccountId && isLegacyProfileInScope(impersonatedAccount, app) ? impersonatedAccount : null;
    var accountsAndImpersonated = allowedImpersonation ? [allowedImpersonation].concat(_toConsumableArray(scopedAccounts || [])) : scopedAccounts;
    var validCurrentAccountId = accountsAndImpersonated !== null && accountsAndImpersonated !== void 0 && accountsAndImpersonated.some(function (_ref4) {
      var id = _ref4.id;
      return id === currentAccountId;
    }) ? currentAccountId : null;
    return {
      accounts: accountsAndImpersonated,
      currentAccountId: validCurrentAccountId,
      currentAccount: !accountsAndImpersonated || !validCurrentAccountId ? null : accountsAndImpersonated.find(function (_ref5) {
        var id = _ref5.id;
        return id === currentAccountId;
      }) || null,
      setCurrentAccountId: handleCurrentAccountId
    };
  }, [app, scopedAccounts, currentAccountId, handleCurrentAccountId, impersonatedAccount, isAdmin]);
  React.useEffect(function () {
    if (state.currentAccountId !== getSessionCurrentAccountId()) setSessionCurrentAccountId(state.currentAccountId);
  }, [state.currentAccountId]);
  return /*#__PURE__*/React.createElement(Provider, {
    value: state
  }, children);
});
AccountsProvider.propTypes = {
  app: PropTypes.oneOf(['paperstac', 'partners', 'noteclosings']),
  children: PropTypes.element.isRequired
};
export default AccountsProvider;
var withAccounts = function withAccounts(Component) {
  return function (props) {
    return /*#__PURE__*/React.createElement(AccountsContext.Consumer, {
      children: function children(contexts) {
        return /*#__PURE__*/React.createElement(Component, _extends({}, props, contexts));
      }
    });
  };
};
export { AccountsContext, withAccounts };